import React from 'react';
import { DataGridPro, GridToolbar } from '@mui/x-data-grid-pro';
import NoDataIcon from 'assets/images/no-data.svg';

import 'styles/MUIDataGrid.scss';

export default function MUIGridGloabl({
	columns,
	dataSource,
	rowCount,
	initialState,
	onRowClick,
	rowSelection,
	onSelectionModelChange,
	selectionModal,
	setPagination = false,
	paginationMode = 'server',
	headerHeight = 45,
	Toolbar = true,
	noRecordsText = '',
	noRecordsCta,
	onColumnVisibilityModelChange,
	columnVisibilityModel,
}: IMUIGloabGrid) {
	return (
		<div style={{ height: '80vh' }} className='w-full bg-white shadow-md'>
			<DataGridPro
				sx={{
					boxShadow: 2,
				}}
				headerHeight={headerHeight}
				rows={dataSource}
				columns={columns}
				rowCount={rowCount}
				pagination={setPagination}
				checkboxSelection={rowSelection}
				paginationMode={paginationMode}
				components={{
					Toolbar: Toolbar && GridToolbar,
					NoRowsOverlay: () => (
						<div className='flex flex-col justify-center items-center gap-3 h-full w-full absolute mx-auto z-50'>
							<img src={NoDataIcon} className='w-14 h-14' alt='nodata' />
							<span className='font-semibold text-xl text-gray-600 capitalize'>
								{noRecordsText}
							</span>
							{noRecordsCta}
						</div>
					),
					NoResultsOverlay: () => (
						<div className='flex flex-col justify-center items-center gap-3 h-full'>
							<span className='font-semibold text-xl text-gray-600 capitalize'>
								Local filter returns no result
							</span>
						</div>
					),
				}}
				onRowClick={onRowClick}
				initialState={initialState}
				onSelectionModelChange={onSelectionModelChange}
				selectionModel={selectionModal}
				columnVisibilityModel={columnVisibilityModel}
				onColumnVisibilityModelChange={onColumnVisibilityModelChange}
			/>
		</div>
	);
}

export interface IMUIGloabGrid {
	columns: any;
	dataSource: [];
	rowCount: number;
	initialState?: any;
	onRowClick?: any;
	rowSelection?: any;
	onSelectionModelChange?: any;
	selectionModal?: any;
	setPagination?: boolean;
	paginationMode?: 'server' | 'client';
	headerHeight?: any;
	gridHeight?: any;
	Toolbar?: boolean;
	onAddButtonTitleClick?: any;
	addButtonTitle?: string;
	noRecordsText?: string;
	noRecordsCta?: any;
	columnVisibilityModel?: any;
	onColumnVisibilityModelChange?: any;
}
